module.exports = __webpack_public_path__ + "img/logo-full.930fa2f5.webp";